import { BackendApiClient } from '../api-client';
import {
  azdanceBookingAuthHeaders,
  extractEventBookingIdFromBookingJwt,
  getAzDanceBookingToken,
} from '@/lib/azdanceBookingSession';

export interface PostBookingParticipantsUpsertParams {
  body: { event_id?: string; participants: Record<string, unknown>[] };
  accessToken?: string;
  language: string;
  /**
   * When the booking JWT includes `eventBookingId`, the backend requires reCAPTCHA (`UpsertBookingParticipants`).
   * Bootstrap (no token / token without booking id) must omit the header.
   */
  recaptchaToken?: string | null;
}

function generateIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return crypto.randomUUID();
  }
  return `idem-${Date.now()}`;
}

/**
 * POST /azdance/booking/participants — единый upsert (bootstrap или с JWT).
 */
export async function postAztangofestBookingParticipantsUpsert(
  params: PostBookingParticipantsUpsertParams,
) {
  const { body, accessToken, language, recaptchaToken } = params;
  const headers: Record<string, string> = {
    ...azdanceBookingAuthHeaders(accessToken ?? undefined),
  };
  const tokenForScope = (accessToken ?? getAzDanceBookingToken() ?? '').trim();
  const needsRecaptcha = Boolean(
    tokenForScope && extractEventBookingIdFromBookingJwt(tokenForScope),
  );
  if (needsRecaptcha && recaptchaToken?.trim()) {
    headers['X-Recaptcha-Token'] = recaptchaToken.trim();
  }
  return BackendApiClient.AzdanceService.azdanceControllerUpsertBookingParticipants(
    { language, idempotencyKey: generateIdempotencyKey(), body: body as any },
    { headers } as any,
  );
}
